<template>
	<div :class="userTipsClasses">
		<div :class="{'new-user-overlay-wrap':true,hide:instructionalTipsLoading}">
			<div :class="{ 'pointer-wrap': true, 'point-right': pointRight }">
				<font-awesome-icon icon="hand-point-up" class="pointer" />
			</div>

			<div class="highlighter" />

			<div class="descriptions">
				<p v-if="tip" :class="{ left: pointRight }">
					<span v-html="tip" />
				</p>
			</div>
		</div>

		<div :class="{'new-user-overlay-fixed':true,hide:!!instructionalTipsLoading}">
			<div class="button-wrap">
				<span
					class="previous"
					@click="backTip"
					v-if="newUserTipIndex > lowestTip && lowestTip > -1"
					v-html="'Previous Tip'"
				/>
				<span class="next" @click="nextTip()" v-html="nextTipLabel" />
				<span class="close" @click="close">close</span>
			</div>
		</div>
		<Loading v-if="instructionalTipsLoading" :text="'One moment...'" />
	</div>
</template>

<script>
	import { mapMutations, mapState } from "vuex";
	import general from "./../utils/general";
	import ApiService from './../services/api.service'
	import Loading from "./Loading.vue";
	export default {
		name: "InstructionTips",
		components: {
			Loading
		},
		props: {
			userInfo: {
				type: Object,
				default: function() {
					return {};
				},
			},
		},
		watch: {
			windowWidth: {
				handler: function(a, b) {
					if (a !== b) {
						if (this.ready) this.setUpTip();
					}
				},
			},
			$route: {
				handler: function(a, b) {
					let aa = a ? a.path : "",
						bb = b ? b.path : "";
					if (aa !== bb) {
						this.ready = false;
						this.shownATip = false;
						this.sendViewed ();
						this.reload();
					}
				},
			},
			instructionalTipsStamp: {
				handler: function(a, b) {
					this.ready = true;
					this.reload();
				},
			},
			userInfo: {
				handler: function(a, b) {
					this.loadTips ();
				},
				deep: true,
			},
		},
		data() {
			return {
				ready: false,
				shownATip: false,
				viewedUniques: [],
				userTips: [],
				currentTip: -1,
				lowestTip: -1,
				lastTip: -1,
				lastTips: {},
				newUserTipIndex: 0,
				showNewUserTips: true,
				windowWidth: window.innerWidth,
				foundMatches: false,
				tip: "",
				pointRight: false,
				theInterval: null,
			};
		},
		computed: {
			...mapState("general", [
				"globalMessage",
				"fullMenu",
				"instructionalTipsStamp",
				"instructionalTipsLoading",
				"instructionalTipsHide"
			]),
			showingTopMessage() {
				return !!this.globalMessage;
			},
			userTipsClasses() {
				let c = {};

				c["new-user-overlay"] = true;

				if ( this.userTips.length ) c[this.userTips[this.newUserTipIndex].type] = true;
				c.show = this.show;

				return c;
			},
			show() {
				return (
					!this.instructionalTipsHide && 
					this.foundMatches &&
					this.showNewUserTips &&
					this.ready &&
					this.currentViable
				);
			},
			nextTipLabel() {
				return !!this.hasANext ? "Next Tip" : "Finish";
			},
			hasANext() {
				if ( !this.userTips.length ) return false;
				let hasAnext = false,
					i = this.newUserTipIndex + 1,
					aa = this.instructionalTipsStamp; // leave this to trigger the watcher!

				if (!!this.userTips[this.newUserTipIndex].click) return true;

				while (!!this.userTips[i]) {
					if (this.viable(i)) {
						hasAnext = true;
					}

					++i;
				}

				return hasAnext;
			},
			currentViable() {
				return this.viable(this.newUserTipIndex);
			},
		},
		methods: {
			...mapMutations("general", ["updateVar", "playSingleVideo"]),

			close () {

				this.showNewUserTips = false;
				this.viewed (this.$route.name);

			},

			playVideo() {
				if (this.userTips[this.newUserTipIndex].video&&this.shownATip) {
					if (
						this.currentTip > 0 &&
						this.userTips[this.newUserTipIndex].routes.indexOf(
							this.$route.name
						) >= 0
					) {
						this.playSingleVideo({
							slug: this.userTips[this.newUserTipIndex].video,
							autoplay: false,
							title: this.userTips[this.newUserTipIndex].tip,
						});
					}
				}
			},

			viable(newUserTipIndex,previous) {
				if (!this.userTips[newUserTipIndex]||!this.userTips[newUserTipIndex]["sync-to-el"]) { 
					return false;
				}
				
				if (
					this.userTips[newUserTipIndex].routes.indexOf(
						this.$route.name
					) < 0 || ( !!this.userTips[newUserTipIndex].viewed && !previous ) 
				)
					return false;

				let routeMatch = true;

				if (!!this.userTips[newUserTipIndex].params) {
					routeMatch = false;

					for (let k in this.userTips[newUserTipIndex].params) {
						if (
							this.$route.params[k] &&
							this.$route.params[k] ===
								this.userTips[newUserTipIndex].params[k]
						)
							routeMatch = true;
					}

				}

				if (
					!document.querySelector(
						this.userTips[newUserTipIndex]["sync-to-el"]
					)
				) {
					
					return false;
				}

				return routeMatch;
			},

			reload() {
				this.showNewUserTips = true;
				this.lowestTip = -1;
				this.currentTip = -1;
				this.newUserTipIndex = 0;
				this.tip = "";
				this.foundMatches = false;
				if (!this.theInterval && this.ready)
					this.theInterval = setInterval(
						function() {
							this.checkFoundMatches();
						}.bind(this),
						200
					);
			},

			backTip() {
				this.nextTip(true);
			},

			checkFoundMatches() {
				let f = false;

				this.userTips.forEach(
					function(tip, index) {
						if (this.viable(index)) {
							f = true;
						}
					}.bind(this)
				);

				this.foundMatches = f;

				if (this.foundMatches)
					setTimeout(
						function() {
							this.setUpTip();
						}.bind(this),
						50
					);
			},

			handleResize() {
				this.windowWidth =
					parseInt(parseInt(window.innerWidth) / 10) * 10;
			},

			setUpTip(scrollIt,previous) {
				if (!this.viable(this.newUserTipIndex,!!previous)) {
					this.nextTip(null,true);
					return;
				}
				let el = document.querySelector(
						this.userTips[this.newUserTipIndex]["sync-to-el"]
					),
					offset = this.userTips[this.newUserTipIndex].offset || {
						left: 5,
						top: 5,
					},
					highlighter = document.querySelector(".highlighter"),
					pointerWrap = document.querySelector(".pointer-wrap"),
					descriptions = document.querySelector(".descriptions");

				if (!highlighter) return;

				if (this.lowestTip < 0) this.lowestTip = this.newUserTipIndex;
				this.currentTip = this.newUserTipIndex;

				if (!!scrollIt) {
					general.scrollElementIntoView(
						this.userTips[this.newUserTipIndex]["sync-to-el"]
					);
				}

				this.tip = this.userTips[this.newUserTipIndex].tip || "";

				this.pointRight = false;

				let rect = el.getBoundingClientRect(),
					top = rect.top + window.scrollY - offset.top,
					left = rect.left + window.scrollX - offset.left,
					width = rect.width + offset.left * 2,
					height = rect.height + offset.top * 2;

				highlighter.style.top = top + "px";
				highlighter.style.left = left + "px";
				highlighter.style.width = width + "px";
				highlighter.style.height = height + "px";

				const descriptionWidth = width < 200 ? 200 : width,
					vw = Math.max(
						document.documentElement.clientWidth || 0,
						window.innerWidth || 0
					);

				descriptions.style.top = top + height + 60 + "px";
				descriptions.style.left = left + "px";
				descriptions.style.right = "auto";
				descriptions.style.width = descriptionWidth + "px";
				descriptions.style.height = height + "px";

				if (descriptionWidth + left > vw) {
					descriptions.style.left = "auto";
					descriptions.style.right = "40px";
				}

				pointerWrap.style.marginTop = top + height + "px";
				pointerWrap.style.left = left + width / 2 + "px";

				if (left < 100||!!this.userTips[this.newUserTipIndex].pointRight) {
					this.pointRight = true;

					left -= 80;

					if (left < 10) left = 10;

					pointerWrap.style.marginTop = top + "px";
					pointerWrap.style.left = left + "px";
					descriptions.style.left = pointerWrap.style.left;
					descriptions.style.top = top + 60 + "px";
				}
				this.shownATip = true;
			},

			viewed (ref) {

				if ( isNaN(ref) ) { // all for current route

					this.userTips.forEach( function (tip,index) {

						if ( tip.routes.indexOf(this.$route.name) >= 0 && !!tip.unique && !tip.viewed ) {

							if ( this.viewedUniques.indexOf( tip.unique) < 0 ) this.viewedUniques.push( tip.unique );
							this.userTips[index].viewed = true;

						}

					}.bind(this));

				}
				else {

					if ( this.viewedUniques.indexOf(this.userTips[ref].unique) < 0 ) this.viewedUniques.push( this.userTips[ref].unique );
					this.userTips[ref].viewed = true;

				}

				if ( !this.hasANext || isNaN(ref) ) this.sendViewed ();

			},

			sendViewed () {

				if ( !this.viewedUniques.length ) return;

				ApiService.post( 'users/instructional-tips', { uniques: this.viewedUniques } )
				.then( function( info ) {

					this.viewedUniques = [];

				}.bind(this))
				.catch( function(err) {}.bind(this));

			},

			loadTips () {

				if ( this.$route.meta.public ) return;

				ApiService.get( 'users/instructional-tips' )
				.then( function( info ) {

					this.userTips = info.data;
					this.reload();

				}.bind(this))
				.catch( function(err) {}.bind(this));

			},

			nextTip(previous,noClick) {

				if ( !noClick ) {

					this.viewed (this.newUserTipIndex);

				}

				let a = !!previous ? this.lastTips[this.newUserTipIndex] : ( this.newUserTipIndex + 1 );
					
				if (!previous&&!noClick&&!!this.userTips[this.newUserTipIndex].click) {
					if (
						!!document.querySelector(this.userTips[this.newUserTipIndex].click)
					) {
						document
							.querySelector(
								this.userTips[this.newUserTipIndex].click
							)
							.click();
					}
					return;
				}
				
				if (a < this.lowestTip) {
					return;
				}

				if (typeof this.userTips[a] !== "undefined") {
					let lastTip = this.newUserTipIndex;
					if (!!previous) {
						this.userTips[this.newUserTipIndex].viewed = false;
						this.newUserTipIndex = this.lastTips[this.newUserTipIndex];
						this.userTips[this.newUserTipIndex].viewed = false;
					} else {
						++this.newUserTipIndex;
						this.playVideo();
						this.lastTips[this.newUserTipIndex] = lastTip;
					}
					if (
						this.userTips[this.newUserTipIndex].maxWidth &&
						this.userTips[this.newUserTipIndex].maxWidth <
							window.innerWidth  && 
						!previous
					) {
						this.nextTip();
						return;
					}
					this.setUpTip(true,!!previous);
				} else {
					this.clearInterval();
					this.showNewUserTips = false;

					window.scrollTo({
						top: 0,
						behavior: "smooth",
					});
					this.$emit("finished");
				}
			},
			clearInterval() {
				if (this.theInterval) clearInterval(this.theInterval);
				this.theInterval = null;
			},
		},
		beforeDestroy() {
			this.clearInterval();
		},
		created() {
			this.loadTips ();
		}
	};
</script>

<style lang="less" scoped>
	@import "./../assets/css/less/_helper.less";
	@import "./../assets/css/less/_settings.less";
	.new-user-overlay {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 999998;
		text-align: center;
		box-sizing: border-box;
		overflow: hidden;
		display: none;

		> .hide {

			.opacity(0);

		}

		&.show {
			display: block;
		}

		.descriptions {
			display: block;
			position: absolute;
			min-width: 200px !important;
			p {
				&.left {
					text-align: left;
					margin: 0;
				}
				span {
					background-color: rgba(0, 0, 0, 0.7);
					color: inherit;
					padding: 10px;
					.rounded(5px);
					display: inline-block;
					text-align: center;
				}
			}
		}

		.pointer-wrap {
			width: 50px;
			height: 50px;
			.trans;
			position: relative;
			z-index: 3;
			display: none;
			margin-left: -25px;

			.pointer {
				width: 100%;
				height: 100%;
				color: @formDefaultColour;
				display: inline-block;
			}

			&.point-right {
				animation: MoveLeftRight 2s linear infinite;
				margin-left: 0;
				.pointer {
					transform: rotate(90deg);
				}
			}

			&:not(.point-right) {
				animation: MoveUpDown 2s linear infinite;
			}
		}

		p {
			color: #fff;
			margin: 0 auto;
			padding: 0;
			.trans;
			position: relative;
			z-index: 2;
			max-width: 400px;
		}

		.highlighter {
			box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.7);
			width: 75px;
			height: 27px;
			top: 95px;
			left: 82px;
			position: absolute;
			z-index: 1;
			border-radius: 4px;
		}

		&.has-top-message {
			.highlighter {
			}

			.pointer-wrap {
			}
		}

		.new-user-overlay-fixed {
			position: fixed;
			bottom: 0;
			left: 10%;
			width: 80%;
			z-index: 999999;

			.button-wrap {
				position: absolute;
				bottom: 20px;
				left: 50%;
				margin-left: -100px;
				width: 200px;
				text-align: right;
			}

			.next,
			.previous {
				display: inline-block;
				font-weight: @bold;
				color: #fff;
				text-align: center;
				background-color: @formDefaultColour;
				padding: 10px;
				cursor: pointer;
				border-radius: 6px;
				width: 120px;
				margin-right: 10px;
				.trans;
				&:hover {
					background-color: @darkContrast;
					color: #fff;
				}
			}

			.previous {
				width: 120px;
				font-size: 14px;
				padding: 12px;
				position: absolute;
				left: -60px;
				right: auto;
			}

			.close {

				position:absolute;
				.trans;
				z-index: 3;
				display: block;
				top: -20px;
				right: -20px;
				width: 20px;
				height: 20px;
				background: url('./../assets/img/close2.svg') center center no-repeat;
				background-size: 100% auto;
				cursor: pointer;
				text-align: center;
				.indent;
				transition: transform .5s ease-in-out;

				&:hover {

					transform: rotate(180deg);

				}

			}

			p {
				color: #fff;
				position: absolute;
				padding: 0;
				margin: 0;
				width: 200px;
				text-align: center;
				bottom: 100px;
				left: 50%;
				margin-left: -100px;
				z-index: 99;
				display: block;
				text-align: center;
				font-size: 20px;
			}
		}
	}

	@media screen and (min-width: 768px) {
		.new-user-overlay {
			
			.pointer-wrap {

				display: block;

			}
			
		}
	}

	@keyframes MoveUpDown {
		0%,
		100% {
			transform: translateY(0);
		}
		50% {
			transform: translateY(15px);
		}
	}
	@keyframes MoveLeftRight {
		0%,
		100% {
			transform: translateX(0);
		}
		50% {
			transform: translateX(15px);
		}
	}
	@keyframes MoveAngle {
		0%,
		100% {
			transform: translateY(0) translateX(0);
		}
		50% {
			transform: translateY(-15px) translateX(15px);
		}
	}
</style>
